import { Tooltip } from '@mui/material';
import React from 'react';
import TextInput from '@Components/DomElements/TextInput';

interface ISearchProps {
    id?: string;
}

const Search = (props: ISearchProps) => {
    return (
        <Tooltip title="Coming soon!">
            <div id={props.id}>
                <TextInput
                    placeholder={'Search'}
                    disabled
                    inputStyle={{
                        cursor: 'not-allowed',
                        width: '225px',
                    }}
                />
            </div>
        </Tooltip>
    );
};

export default Search;
